import React, { useEffect, useState } from 'react';

import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment } from '@material-ui/icons';
import { TextField } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { wsGetAll, wsUpdate } from 'services/WService';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';

import { onlyMoney } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: '500',
  },
  table: {
    minWidth: 650,
  },
  tr: {
    backgroundColor: 'rgb(151, 47, 176)',
    '& th': {
      color: 'white'
    }
  },
});

function InputField(props) {
  return (
    <TextField
      {...props}
      onKeyPress={onlyMoney}
      style={{ marginTop: 0, marginBottom: '3px' }}
      margin="normal"
      size="small"
      fullWidth
      inputProps={{ ...props.inputProps, style: { textAlign: props.type === 'text' ? 'left' : 'right' } }}
    />
  );
};

export default WithApp(function Reward(props) {
  const { incentive, showNotify, reload } = props;
  const classes = useStyles();

  const [rewards, setRewards] = useState([]);
  const [updated, setUpdated] = useState(false);

  const [excelData, setExcelData] = useState({ success: false, nameFile: '', data: [] });

  // Mostrar esta data y construir un excel
  async function loadRewardData(){
    let response = await wsGetAll(`com/incentive/${incentive.id}/excel-reward-data`);
    setRewards(response.data.map(reward => {
      reward.updated = false;
      return reward;
    }));
  }

  useEffect(() => {
    loadRewardData();
  }, [incentive]);

  // Guardado de excel
  useEffect(() => {
    if(excelData.success === false){
      return;
    }

    let data = [];
    for(let item of excelData.data){
      // 'Codigo', 'VolumenMinorista', 'CoberturaMinorista', 'VolumenMayorista', 'CoberturaMayorista'
      if(rewards.find(reward => reward.id == item.Codigo) === null){
        showNotify(`El item de código ${item.Codigo} no existe en las recompensas`, 'error');
        setExcelData({ success: false, nameFile: '', data: [] });
      }

      data.push({
        com_incentive_category_id: item.Codigo,
        rewardMinVolume: item.VolumenMinorista,
        rewardMinCoverage: item.CoberturaMinorista,
        rewardMayVolume: item.VolumenMayorista,
        rewardMayCoverage: item.CoberturaMayorista,
      });
    }

    wsUpdate(`com/incentive/${incentive.id}/update-rewards`, {
      categories: data,
    }).then(() => {
      showNotify(`Recompensas actualizadas`, 'success');
      loadRewardData();
      setExcelData({ success: false, nameFile: '', data: [] });
    }).catch(() => {
      showNotify(`Error al actualizar las recompensas`, 'error');
      setExcelData({ success: false, nameFile: '', data: [] });
    });
  }, [excelData]);

  async function saveRewards(){
    if(updated === false){
      return;
    }
    let rewardsToSave = rewards.filter(reward => reward.updated).map(reward => {
      reward.com_incentive_category_id = reward.id;
      return reward;
    });
    let response = await wsUpdate(`com/incentive/${incentive.id}/update-rewards`, {
      categories: rewardsToSave,
    });

    if(response.success){
      setRewards(response.data.map(reward => {
        reward.updated = false;
        return reward;
      }));
      setUpdated(false);
      showNotify(response.message, 'success');
    }else{
      showNotify(response.message, 'error');
    }

  }

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary" pointer="true">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Recompensas</h4>
      </CardHeader>

      <CardBody>
        <GridContainer>
          <GridItem xs={12} md={12} lg={12}>
            <ImportExcel
              setDataImport={setExcelData}
              btnColor="success"
              btnLabel="Importar"
              validDuplicate="Codigo"
              sortDuplicate="Codigo"
              downTemplate={{
                fileNameDown: 'recompensas',
                fields: [
                  'Codigo',
                  'VolumenMinorista',
                  'CoberturaMinorista',
                  'VolumenMayorista',
                  'CoberturaMayorista'
                ]
              }}
            />
          </GridItem>

          <GridItem xs={12} md={12} lg={12}>
            <div
              style={{
                marginBottom: '15px',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderImage: 'linear-gradient(to top, white, #972fb0) 1',
                borderRadius: '2px'
              }}
            >
              <Table size="small" aria-label="Tabla de recompensas">
                <TableHead>
                  <TableRow className={classes.tr}>
                    <TableCell rowSpan={2}>Código</TableCell>
                    <TableCell rowSpan={2}>Grupo proveedor</TableCell>
                    <TableCell rowSpan={2}>Tipo incentivo</TableCell>
                    <TableCell rowSpan={2}>Tipo item</TableCell>
                    <TableCell rowSpan={2}>Descripción</TableCell>
                    <TableCell colSpan={2} align="center">
                      Minorista
                    </TableCell>
                    <TableCell colSpan={2} align="center">
                      Mayorista
                    </TableCell>
                  </TableRow>
                  <TableRow className={classes.tr}>
                    <TableCell width="150">Volumen</TableCell>
                    <TableCell width="150">Cobertura</TableCell>
                    <TableCell width="150">Volumen</TableCell>
                    <TableCell width="150">Cobertura</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rewards.map((reward, index) => (
                    <RewardRow reward={reward} key={index} setRewards={setRewards} setUpdated={setUpdated} index={index}/>
                  ))}
                </TableBody>
              </Table>
            </div>
          </GridItem>

          <GridItem xs={12} md={12} lg={12}>
            <Button color={props.themeContext.buttonColorSuccess} onClick={() => saveRewards()} disabled={!updated} style={{ float: 'right' }}>
              Guardar
            </Button>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
})

function RewardRow(props) {
  const { reward, index, setRewards, setUpdated } = props;

  function handleChange(e) {
    setUpdated(updated => {
      if(updated === false){
        return true;
      }else{
        return updated;
      }
    });

    let element = e.target;
    setRewards(rewards => updateReward(rewards, element.name, element.value));
  }

  function updateReward(rewards, name, value){
    let newRewards = [...rewards];
    newRewards[index][name] = value;
    newRewards[index].updated = true;
    return newRewards;
  }

  return (
    <TableRow>
      <TableCell>{reward.id}</TableCell>
      <TableCell>{reward.provider_group_description}</TableCell>
      <TableCell>{reward.incentive_type}</TableCell>
      <TableCell>{reward.item_type}</TableCell>
      <TableCell>{reward.item_code + ' ' + reward.item_description}</TableCell>
      <TableCell>
        <InputField
          type="number" name="rewardMinVolume"
          value={parseFloat(reward.rewardMinVolume ?? 0)}
          onChange={handleChange}
          inputProps={{ min: 0, step: 0.01 }}
        />
      </TableCell>
      <TableCell>
        <InputField
          type="number" name="rewardMinCoverage"
          value={parseFloat(reward.rewardMinCoverage ?? 0)}
          onChange={handleChange}
          inputProps={{ min: 0, step: 0.01 }}
        />
      </TableCell>
      <TableCell>
        <InputField
          type="number" name="rewardMayVolume"
          value={parseFloat(reward.rewardMayVolume ?? 0)}
          onChange={handleChange}
          inputProps={{ min: 0, step: 0.01 }}
        />
      </TableCell>
      <TableCell>
        <InputField
          type="number" name="rewardMayCoverage"
          value={parseFloat(reward.rewardMayCoverage ?? 0)}
          onChange={handleChange}
          inputProps={{ min: 0, step: 0.01 }}
        />
      </TableCell>
    </TableRow>
  );
}
